export enum DocumentPrintOrderType {
  OrderId,
  OrderNumber,
}
